import Vue from "vue";
import Router from "vue-router";
import IndexApi from "./../public/";
import store from "./../store";
import details from "./details";
import sysRouter from "./sysrouter";
//路由懒加载
const index = resolve => require(["@/components/index"], resolve);
const login = resolve => require(["@/components/login"], resolve);
const register = resolve => require(["@/components/register"], resolve);
const notFound = resolve => require(["@/components/404"], resolve);
Vue.use(Router);
const routes = [
  {
    path: "/index",
    name: "index",
    component: index,
    meta: {
      name: "index",
      requireAuth: true,
      title: "首页"
    },
    children: [
      ...sysRouter,
      {
        path: "viewregistinfo",
        name: "viewregistinfo",
        meta: {
          name: "viewregistinfo",
          title: "查看注册信息"
        },
        component: resolve =>
          require(["@/components/my/viewregistinfo"], resolve)
      },
      {
        path: "registindex",
        name: "registindex",
        meta: {
          name: "registindex",
          title: "准入申请"
        },
        component: resolve => require(["@/components/my/registindex"], resolve)
      },
      {
        path: "myinfo",
        name: "myinfo",
        meta: {
          name: "myinfo",
          title: "我的信息"
        },
        component: resolve => require(["@/components/public/myinfo"], resolve)
      },
      {
        path: "addBillApply",
        name: "addBillApply",
        meta: {
          name: "addBillApply",
          title: "申请对账"
        },
        component: resolve =>
          require(["@/components/finance/addBillApply"], resolve)
      },
      {
        path: "addCheckGoodsApply",
        name: "addCheckGoodsApply",
        meta: {
          name: "addCheckGoodsApply",
          title: "验货申请"
        },
        component: resolve =>
          require(["@/components/order/addCheckGoodsApply"], resolve)
      },
      {
        path: "editInfo",
        name: "editInfo",
        meta: {
          name: "editInfo",
          title: "修改资料"
        },
        component: resolve => require(["@/components/my/editInfo"], resolve)
      },
      {
        path: "updOrderQtyApply",
        name: "updOrderQtyApply",
        meta: {
          name: "updOrderQtyApply",
          // title: "申请超合同数"
          title: "申请实裁数"
        },
        component: resolve =>
          require(["@/components/order/updOrderQtyApply"], resolve)
      },
      {
        path: "/index/*",
        name: "indexMain",
        component: login
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    meta: {
      name: "login",
      title: "登录"
    },
    component: login
  },
  {
    path: "/",
    name: "main",
    meta: {
      name: "login",
      title: "登录"
    },
    component: login
  },
  {
    path: "/register:id",
    name: "register",
    meta: {
      name: "register",
      title: "供应商注册"
    },
    component: register
  },
  {
    path: "/questionAndAnswer",
    name: "questionAndAnswer",
    meta: {
      name: "questionAndAnswer",
      title: "常见问题解答"
    },
    component: resolve => require(["@/pages/question/answer"], resolve)
  },
  ...details,
  {
    path: "/*",
    name: "404",
    meta: {
      name: "404",
      title: "找不到网页！"
    },
    component: notFound
  }
];

if (IndexApi.RouterList) {
  getRouterList(IndexApi.RouterList, false); //暂不执行自动创建路由
} /**/
//状态判断 80 success
console.log("状态判断 80 success", IndexApi.userInfo);
if (
  IndexApi.userInfo.entityStatus != "70" &&
  IndexApi.userInfo.entityStatus != "80" &&
  IndexApi.userInfo.entityStatus != "90"
) {
  //正式供应商
  routes[0].children.unshift({
    path: "/",
    name: "readyIndex",
    meta: {
      name: "readyIndex",
      title: "公司资料"
    },
    component: resolve => require(["@/components/my/readyIndex"], resolve)
  });
}

function getRouterList(arr, parent) {
  //遍历获取子路由
  for (var i = 0; i < arr.length; i++) {
    (function(num) {
      let rName = "";
      if (arr[num].childAuthority && arr[num].childAuthority instanceof Array) {
        let p = {
          title: arr[num].authorityName,
          name: arr[num].routerName
        };
        getRouterList(arr[num].childAuthority, p);
      } else {
        if (parent instanceof Object) {
          //
          var path = parent.name + "/"; //组件路径
          var names;

          if (!!arr[num].routerName) {
            names = arr[num].routerName.split("$");
            rName = names[0];
            var key = false;
            if (names.length > 1) {
              //说明有切换
              var fullPath = path + "index"; //切换指向index
              key = names[1];
            } else {
              //说明没有切换
              var fullPath = path + rName; //无切换使用routername明明
            }
            var temp = {
              path: rName,
              name: rName,
              meta: {
                authorityId: arr[num].authorityId,
                requireAuth: true,
                name: rName,
                title: arr[num].authorityName,
                parentTitle: parent.title,
                parentName: parent.name
              },
              component: resolve =>
                require([`@/${resetFullPath(fullPath)}.vue`], resolve)
            };
            if (key !== false) {
              temp.meta.key = key;
            }
          }
        } else {
          //直接子集
          var fullPath = arr[num].routerName + "/index";
          rName = arr[num].routerName;
          var temp = {
            path: rName,
            name: rName,
            meta: {
              authorityId: arr[num].authorityId,
              requireAuth: true,
              title: arr[num].authorityName,
              name: rName
            },
            component: resolve =>
              require([`@/${resetFullPath(fullPath)}.vue`], resolve)
          };
        }
        let isAdd = true;
        routes[0].children.forEach(function(v, i) {
          if (rName == v.name) {
            isAdd = false;
          }
        });
        if (isAdd && temp) {
          routes[0].children.unshift(temp);
        }
      }
    })(i);
  }
}
// 设置页面文件的引用路径（新页面的文件放置在pages文件夹）
function resetFullPath(fullPath) {
  const folderComponent = [
    "dataBoard/dataBoard",
    "order/OrderProgressFinish",
    "order/OrderProgressMaterial",
    "order/orderList",
    "order/orderListRaw",
    "materialManagement/barcodeReturn",
    "materialManagement/barcodeApplication",
    "reportManagement/inspectionDetail",
    "reportManagement/externalAccessories",
    "reportManagement/supplierReconciliation",
    "reportManagement/implementationFinish",
    "reportManagement/implementationMaterial",
    "informationManagement/notice",
    "my/assessmentReport",
    "order/tailoringPackList",
    "order/deliveryNote",
    "materialManagement/blank",
    "fileManagement/fileList",
    "materialManagement/externalCooperation/deliverList",
    "materialManagement/replenishmentApply",
    "materialManagement/returnApply",
    "fabricSeasoning/FabricDistribution",
    "fabricSeasoning/FabricReconciliation",
    "finance/PrepaymentTaxInvoice",
    "finance/billApplyList",
    "finance/ConsignmentSalesReconciliation"
  ];
  if (folderComponent.includes(fullPath)) return `pages/${fullPath}/index`;
  else return `components/${fullPath}`;
}

function setRouterKey(arg) {
  if (JSON.stringify(arg) !== "{}" && arg.name != "login") {
    store.dispatch("routekey/getState", arg);
  }
}

const router = new Router({
  mode: "history",
  routes: routes
});
//debugger;
router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token")) {
    //是否已经登录
    if (IndexApi.RouterList) {
      //已经存了左侧列表
      setRouterKey(to.meta);
      next();
    } else {
      // window.location.href = "/"; //刷新页面获得路由表
      next();
    }
  } else {
    if (to.matched.some(res => res.meta.requireAuth)) {
      // 判断是否需要登录权限
      setRouterKey(to.meta);
      next({
        path: "/Login",
        query: { redirect: to.fullPath }
      });
    } else {
      setRouterKey(to.meta);
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js